import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ResponseBase} from "../../data";
import {Code, Script, Variables, Event} from "../../data/pythonScript";

export interface PythonScriptState {
    response: ResponseBase | null
    loading: boolean,
    error: ResponseBase | null,
    requestFinished: boolean,
    codeList: Code[],
    selectedCode: Code,
    script: Script,
    variablesList: Variables[],
    eventList: Event[]
}

const initialPythonScriptState: PythonScriptState = {
    response: null,
    loading: false,
    error: null,
    requestFinished: false,
    codeList: [],
    selectedCode: {} as Code,
    script: {} as Script,
    variablesList: [],
    eventList: []
}

const pythonScriptSlice = createSlice({
    name: 'pythonScript',
    initialState: initialPythonScriptState,
    reducers: {
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.loading = false;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setCodeList(state, action: PayloadAction<Code[]>) {
            state.codeList = action.payload;
            state.loading = false;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.loading = false;
            state.error = action.payload;
        },
        setRequestFinished(state, action: PayloadAction<boolean>) {
            state.requestFinished = action.payload;
            state.loading = false;
        },
        setSelectedCode(state, action: PayloadAction<Code>) {
            state.selectedCode = action.payload;
            state.loading = false;
        },
        setScriptList(state, action: PayloadAction<Script>) {
            state.script = action.payload;
            state.loading = false;
        },
        setVariablesList(state, action: PayloadAction<Variables[]>) {
            state.variablesList = action.payload;
            state.loading = false;
        },
        setEventList(state, action: PayloadAction<Event[]>) {
            state.eventList = action.payload;
            state.loading = false;
        },
    }
});

export const pythonScriptActions = pythonScriptSlice.actions;
export default pythonScriptSlice;
